import { lazy } from 'react';

export default lazy(() => import('mfReporting/Analytics'));
